// extracted by mini-css-extract-plugin
export default {"contact-information":"Contact_contact-information__WepI7","icon":"Contact_icon__+WyG+","contact-column":"Contact_contact-column__plfKq"};